import Vue from "vue";
import VueRouter from "vue-router";
import VueCookies from "vue-cookies";
const originalPush = VueRouter.prototype.push;
//增强push
VueRouter.prototype.push = function (location, okCallback, errCallback) {
  //若程序员使用push的时候，没有传递成功、失败的回调，那就靠catch
  if (okCallback === undefined && errCallback === undefined) {
    return originalPush.call(this, location).catch(() => {});
  } else {
    //若程序员使用push的时候，传递了成功、失败的回调，那就用
    return originalPush.call(this, location, okCallback, errCallback);
  }
};
//创世荣耀藏品
const Exchange = () => import("@/views/Exchange");

//唱片藏品
const Record = () => import("@/views/Record");
//老虎藏品
const Tiger = () => import("@/views/Tiger");

//查看创世荣耀藏品编号种类
const ChangeNum = () => import("@/views/ChangeNum");

//原宇宙软件许可服务协议
const ServeDeal = () => import("@/views/ServeDeal");

//原宇宙隐私保护指引
const IntimityGuide = () => import("@/views/IntimityGuide");

//原宇宙下载页
const Install = () => import("@/views/Install");

//乐乐虎
const laughTiger = () => import("@/views/laughTiger");

//兔子藏品
const Rabbit = () => import("@/views/Rabbit");

const PaName = () => import("@/views/PaName");

//朋克模块
const Punk = () => import("@/views/Punktest/Punk");

//朋克模块首页
const PunkHome = () => import("@/views/Punktest/PunkHome");

//朋克模块藏品画廊
const PunkGallery = () => import("@/views/Punktest/PunkGallery");

//朋克模块藏品详情
const CollectionDetail = () => import("@/views/Punktest/CollectionDetail");

//朋克模块探索属性
const PunkAttr = () => import("@/views/Punktest/PunkAttr");

//正式朋克页面

//朋克模块
const Punkdev = () => import("@/views/Punk/Punk");

//朋克模块首页
const PunkHomedev = () => import("@/views/Punk/PunkHome");

//朋克模块藏品画廊
const PunkGallerydev = () => import("@/views/Punk/PunkGallery");

//朋克模块藏品详情
const CollectionDetaildev = () => import("@/views/Punk/CollectionDetail");

//朋克模块探索属性
const PunkAttrdev = () => import("@/views/Punk/PunkAttr");

//无聊猿测试模块
const BoredMonkey = () => import("@/views/BoredMonkeyTest/Bored.vue");
const BoredHome = () => import("@/views/BoredMonkeyTest/BoredHome");
const BoredDetail = () => import("@/views/BoredMonkeyTest/BoredDetail");

//无聊猿模块
const BoredMonkeydev = () => import("@/views/BoredMonkey/Bored.vue");
const BoredHomedev = () => import("@/views/BoredMonkey/BoredHome");
const BoredDetaildev = () => import("@/views/BoredMonkey/BoredDetail");

let baseURL = "https://api-test.lbtb.org.cn/token";

Vue.use(VueRouter);

const routes = [
     //钱包管理
     {
      path: "/pursemanage",
      component: () => import("@/views/PurseManage"),
      meta: { proPlus: true },
    },
     //邀请详情
     {
      path: "/apple",
      component: () => import("@/views/Apple"),
      meta: { proPlus: true },
    },
   //邀请详情
   {
    path: "/invitedetail",
    component: () => import("@/views/InviteFriends/detail"),
    meta: { proPlus: true },
  },
  //邀请好友
    {
      path: "/invitefriends",
      component: () => import("@/views/InviteFriends"),
      meta: { proPlus: true },
    },




  //生肖龙
    {
      path: "/dragon",
      component: () => import("@/views/Dragon.vue"),
    },



  //原宇宙模块

  {
    path: "/original",
    component: () => import("@/views/Original"),
    meta: { pro: true, original: true },
    children: [
      //登录页
      {
        path: "login",
        component: () => import("@/views/Original/login"),
        meta: { pro: true },
      },
      {
        path: "test",
        component: () => import("@/views/Original/test"),
      },
      //首页
      {
        path: "home",
        component: () => import("@/views/Original/home"),
        meta: { pro: true, original: true },
      },
      //合规声明
      {
        path: "statcompliance",
        component: () => import("@/views/Original/Statcompliance.vue"),
      },
      //藏品详情
      {
        path: "discdetail",
        component: () => import("@/views/Original/discDetail.vue"),
        meta: { pro: true, original: true },
      },
      //转赠
      {
        path: "givesth",
        component: () => import("@/views/Original/givesth.vue"),
        meta: { pro: true, original: true },
      },
      //确认转赠
      {
        path: "definitetransfer",
        component: () => import("@/views/Original/definiteTransfer.vue"),
        meta: { pro: true, original: true },
      },
      //藏品记录
      {
        path: "records",
        component: () => import("@/views/Original/records.vue"),
        meta: { pro: true, original: true },
      },
      //设置操作密码
      {
        path: "setpassword",
        component: () => import("@/views/Original/setPassword.vue"),
        meta: { pro: true, original: true },
      },

      //已经设置了操作密码
      {
        path: "pawsuccess",
        component: () => import("@/views/Original/pawsuccess.vue"),
        meta: { pro: true, original: true },
      },

      //填身份证号
      {
        path: "cardnum",
        component: () => import("@/views/Original/cardnum.vue"),
        meta: { pro: true, original: true },
      },
    ],
  },

  //原子消消乐
  {
    path: "/yuanzixiaogame",
    component: () => import("@/views/yuanzixiaoxiaole.vue"),
  },
  //无聊猿测试模块
  {
    path: "/monkey",
    component: BoredMonkey,
    children: [
      //首页
      {
        path: "home",
        component: BoredHome,
      },
      //详情页
      {
        path: "houzixiangqing",
        component: BoredDetail,
      },
    ],
  },
  //胖企鹅
  {
    path: "/lilpudgysdev",
    component: () => import("@/views/Lilpudgys/index.vue"),
    children: [
      //首页
      {
        path: "home",
        component: () => import("@/views/Lilpudgys/home.vue"),
      },
      //详情页
      {
        path: "qiexiangqing",
        component: () => import("@/views/Lilpudgys/detail.vue"),
      },
    ],
  },
    //无聊猿正式!!模块
    {
      path: "/monkeydev",
      component: BoredMonkeydev,
      children: [
        //首页
        {
          path: "home",
          component: BoredHomedev,
        },
        //详情页
        {
          path: "houzixiangqing",
          component: BoredDetaildev,
        },
      ],
    },

  //朋克模块
  {
    path: "/punk",
    component: Punk,
    children: [
      //首页
      {
        path: "home",
        component: PunkHome,
      },
      //藏品画廊
      {
        path: "gallery",
        component: PunkGallery,
        meta: { requiresAuth: "GALLERY" },
      },
      //藏品详情
      {
        path: "detail",
        component: CollectionDetail,
      },
      //探索属性
      {
        path: "attr",
        component: PunkAttr,
        meta: { requiresAuth: "ATTRIBUTES" },
      },
    ],
  },

  //正式朋克

  //朋克模块
  {
    path: "/punkdev",
    component: Punkdev,
    children: [
      //首页
      {
        path: "home",
        component: PunkHomedev,
      },
      //藏品画廊
      {
        path: "gallery",
        component: PunkGallerydev,
        meta: {
          requiresAuth: "GALLERY",
          isKeepAlive: true,
        },
      },
      //藏品详情
      {
        path: "detail",
        component: CollectionDetaildev,
      },
      //探索属性
      {
        path: "attr",
        component: PunkAttrdev,
        meta: {
          requiresAuth: "ATTRIBUTES",
        },
      },
    ],
  },

  //用户协议
  {
    path: "/userdeal",
    component: () => import("@/views/UserDeal"),
  },
  //隐私政策
  {
    path: "/privacypolicy",
    component: () => import("@/views/PrivacyPolicy"),
  },
  //爬虫
  {
    path: "/PaName",
    component: PaName,
  },
  {
    path: "/exchange",
    name: "exchange",
    component: Exchange,
  },
  {
    path: "/record",
    name: "record",
    component: Record,
  },
  {
    path: "/tiger",
    name: "tiger",
    component: Tiger,
  },
  {
    path: "/changenum",
    name: "ChangeNum",
    component: ChangeNum,
  },
  {
    path: "/servedeal",
    name: "ServeDeal",
    component: ServeDeal,
  },
  {
    path: "/intimityguide",
    name: "IntimityGuide",
    component: IntimityGuide,
  },

  //下载官网
  {
    path: "/",
    name: "Install",
    component: Install,
  },
  //乐乐虎
  {
    path: "/laughtiger",
    name: "laughTiger",
    component: laughTiger,
  },
  //兔子藏品
  {
    path: "/rabbit",
    name: "rabbit",
    component: Rabbit,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 定义路径分类
    const arr = ["/punkdev/home", "/punkdev/detail"];
    const specificPaths = ["houzixiangqing", "qiexiangqing"];
    const isToSpecificPath = specificPaths.some((path) => to.path.includes(path));
    const isFromAttrToGallery =
      from.path.includes("attr") && to.path.includes("gallery");
  
    // 优化条件判断
    if (from.path.includes("detail") && to.path.includes("gallery")) {
      return savedPosition;
    }
    if (
      isToSpecificPath ||
      arr.includes(to.path) ||
      arr.includes(from.path) ||
      isFromAttrToGallery ||
      from.meta.pro
    ) {
      return { x: 0, y: 0 };
    }
    return savedPosition;
  }
});

router.beforeEach((to, from, next) => {
  const userInfoCookie = VueCookies.get("userInfo");
  // console.log(userInfoCookie, "userInfoCookie");
  if (to.fullPath.includes("dev") || to.meta.pro) {
    baseURL = "https://api.bkct.net/token";
  }else if(to.meta.proPlus) baseURL = "https://api.bkct.net";

  if (userInfoCookie && userInfoCookie.token) {
    next();
    return;
  } else if (to.meta.original) {
    next("original/login");
    return;
  } else {
    next();
  }
  // next()
});

export { baseURL };

export default router;
